<!-- =========================================================================================
    File Name: TheCustomizer.vue
    Description: Template Customizer
    Component Name: TheCustomizer
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="theme-customizer">
    <vx-tooltip class="customizer-btn-filter" text="Filter vessel" position="left">
      <vs-button
        @click.stop="active=!active,getVesselData()"
        color="primary"
        icon-pack="feather"
        icon="icon-filter"
      ></vs-button>
    </vx-tooltip>
    <vs-sidebar
      hidden-background
      position-right
      v-model="active"
      click-not-close
      class="items-no-padding"
    >
      <div class="h-full">
        <div class="customizer-header mt-6 flex items-center justify-between px-6">
          <div>
            <h4>Filter Vessel</h4>
          </div>
          <feather-icon icon="XIcon" @click.stop="active = false" class="cursor-pointer"></feather-icon>
        </div>
        <vs-divider class="mb-0"></vs-divider>
        <div class="mt-3 mr-2 ml-2">
          <vs-input class="w-full" label-placeholder="Name" placeholder="Name" v-model="name" />
          <vs-select class="w-full mt-2" v-model="shipClass" placeholder="Ship class">
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item,index) in shipClasses"
            />
          </vs-select>
          <vs-select class="w-full mt-2" v-model="shipType" placeholder="Ship type">
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item,index) in shipTypes"
            />
          </vs-select>
          <vs-select class="w-full mt-2" v-model="vesselGroup" placeholder="Vessel group">
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item,index) in vesselGroups"
            />
          </vs-select>
          <vs-select class="w-full mt-2" v-model="navigationStatus" placeholder="Navigation Status">
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item,index) in navigationStatuss"
            />
          </vs-select>
          <vs-button
            color="primary"
            icon-pack="feather"
            icon="icon-search"
            class="w-full mt-2"
            type="relief"
            @click="flitterVessel()"
          >Sarech</vs-button>
        </div>
        <vs-divider class="mb-0"></vs-divider>
        <VuePerfectScrollbar class="scroll-area--customizer pt-4 pr-2">
          <vs-table stripe>
            <template>
              <vs-tr>
                <vs-th>MMIS</vs-th>
                <vs-th>Name</vs-th>
                <vs-th>IMO</vs-th>
              </vs-tr>
            </template>

            <template>
              <tbody>
                <vs-tr v-for="vessel in flitterVesselData" :key="vessel">
                  <vs-td>{{vessel.mmsi}}</vs-td>
                  <vs-td>{{vessel.name}}</vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </VuePerfectScrollbar>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import axios from "axios";
import MarkerClusterer from "@google/markerclusterer";
import gmapsInit from "@/gmap/gmaps";
import { SERVER_SYNC_INTERVAL, API_BASE_URL } from "@/constants";
import { lstat } from "fs";
import { mapState } from "vuex";

export default {
  props: {},
  data() {
    return {
      navigationStatuss: [
        { text: "Under way using engine", value: "Under way using engine" },
        { text: "At anchor", value: "At anchor" },
        { text: "Not under command", value: "Not under command" },
        {
          text: "Restricted manoeuverability",
          value: "Restricted manoeuverability"
        },
        {
          text: "Constrained by her draught",
          value: "Constrained by her draught"
        },
        { text: "Moored", value: "Moored" },
        { text: "Aground", value: "Aground" },
        { text: "Engaged in Fishing", value: "Engaged in Fishing" },
        { text: "Under way sailing", value: "Under way sailing" },
        {
          text: "Reserved for future amendment of Navigational Status for HSC",
          value: "Reserved for future amendment of Navigational Status for HSC"
        },
        {
          text: "Reserved for future amendment of Navigational Status for WIG",
          value: "Reserved for future amendment of Navigational Status for WIG"
        },
        { text: "Reserved for future use", value: "Reserved for future use" },
        { text: "AIS-SART is active", value: "AIS-SART is active" },
        { text: "Not defined (default)", value: "Not defined (default)" }
      ],
      vesselGroups: [
        { text: "Excise-tanker", value: "1" },
        { text: "Excise-tanker-shipping", value: "2" }
      ],
      shipClasses: [
        { text: "A", value: "A" },
        { text: "B", value: "B" }
      ],
      shipTypes: [
        { text: " ", value: "0" },
        { text: "All vessel", value: "1" },
        { text: "Not available (default)", value: "Not available (default)" },
        {
          text: "Wing in ground (WIG), all ships of this type",
          value: "Wing in ground (WIG), all ships of this type"
        },
        {
          text: "Wing in ground (WIG), Hazardous category A",
          value: "Wing in ground (WIG), Hazardous category A"
        },
        {
          text: "Wing in ground (WIG), Hazardous category A",
          value: "Wing in ground (WIG), Hazardous category B"
        },
        {
          text: "Wing in ground (WIG), Hazardous category A",
          value: "Wing in ground (WIG), Hazardous category C"
        },
        {
          text: "Wing in ground (WIG), Hazardous category A",
          value: "Wing in ground (WIG), Hazardous category D"
        },
        { text: "Fishing", value: "Fishing" },
        { text: "Towing", value: "Towing" },
        {
          text: "Towing: length exceeds 200m or breadth exceeds 25m",
          value: "Towing: length exceeds 200m or breadth exceeds 25m"
        },
        {
          text: "Dredging or underwater ops",
          value: "Dredging or underwater ops"
        },
        { text: "Diving ops", value: "Diving ops" },
        { text: "Military ops", value: "Military ops" },
        { text: "Sailing", value: "Sailing" },
        { text: "Pleasure Craft", value: "Pleasure Craft" },
        {
          text: "High speed craft (HSC), all ships of this type",
          value: "High speed craft (HSC), all ships of this type"
        },
        {
          text: "High speed craft (HSC), Hazardous category A",
          value: "High speed craft (HSC), Hazardous category A"
        },
        {
          text: "High speed craft (HSC), Hazardous category B",
          value: "High speed craft (HSC), Hazardous category B"
        },
        {
          text: "High speed craft (HSC), Hazardous category B",
          value: "High speed craft (HSC), Hazardous category C"
        },
        {
          text: "High speed craft (HSC), Hazardous category D",
          value: "High speed craft (HSC), Hazardous category D"
        },
        {
          text: "High speed craft (HSC), No additional information",
          value: "High speed craft (HSC), No additional information"
        },
        { text: "Pilot Vessel", value: "Pilot Vessel" },
        { text: "Search and Rescue vessel", value: "Search and Rescue vessel" },
        { text: "Tug", value: "Tug" },
        { text: "Port Tender", value: "Port Tender" },
        { text: "Anti-pollution equipment", value: "Anti-pollution equipment" },
        { text: "Law Enforcement", value: "Law Enforcement" },
        { text: "Spare - Local Vessel", value: "Spare - Local Vessel" },
        { text: "Medical Transport", value: "Medical Transport" },
        {
          text: "Noncombatant ship according to RR Resolution No. 18",
          value: "Noncombatant ship according to RR Resolution No. 18"
        },
        {
          text: "Passenger, all ships of this type",
          value: "Passenger, all ships of this type"
        },
        {
          text: "Passenger, Hazardous category A",
          value: "Passenger, Hazardous category A"
        },
        {
          text: "Passenger, Hazardous category B",
          value: "Passenger, Hazardous category B"
        },
        {
          text: "Passenger, Hazardous category C",
          value: "Passenger, Hazardous category C"
        },
        {
          text: "Passenger, Hazardous category D",
          value: "Passenger, Hazardous category D"
        },
        {
          text: "OPassenger, No additional informationther",
          value: "Passenger, No additional information"
        },
        {
          text: "Cargo, all ships of this type",
          value: "Cargo, all ships of this type"
        },
        {
          text: "Cargo, Hazardous category A",
          value: "Cargo, Hazardous category A"
        },
        {
          text: "Cargo, Hazardous category B",
          value: "Cargo, Hazardous category B"
        },
        {
          text: "Cargo, Hazardous category C",
          value: "Cargo, Hazardous category C"
        },
        {
          text: "Cargo, Hazardous category D",
          value: "Cargo, Hazardous category D"
        },
        {
          text: "Cargo, No additional information",
          value: "Cargo, No additional information"
        },
        {
          text: "Tanker, all ships of this type",
          value: "Tanker, all ships of this type"
        },
        {
          text: "Tanker, Hazardous category A",
          value: "Tanker, Hazardous category A"
        },
        {
          text: "Tanker, Hazardous category B",
          value: "Tanker, Hazardous category B"
        },
        {
          text: "Tanker, Hazardous category C",
          value: "Tanker, Hazardous category C"
        },
        {
          text: "Tanker, Hazardous category D",
          value: "Tanker, Hazardous category D"
        },
        {
          text: "Tanker, No additional information",
          value: "Tanker, No additional information"
        },
        {
          text: "Other Type, all ships of this type",
          value: "Other Type, all ships of this type"
        },
        {
          text: "Other Type, Hazardous category A",
          value: "Other Type, Hazardous category A"
        },
        {
          text: "Other Type, Hazardous category B",
          value: "Other Type, Hazardous category B"
        },
        {
          text: "Other Type, Hazardous category C",
          value: "Other Type, Hazardous category C"
        },
        {
          text: "Other Type, Hazardous category D",
          value: "Other Type, Hazardous category D"
        },
        {
          text: "Other Type, no additional information",
          value: "Other Type, no additional information"
        }
      ],
      shipClass: "",
      shipType: "",
      vesselGroup: "",
      navigationStatus: "",
      active: false,
      valueSearch: "",
      vesselData: [],
      flitterVesselData: [],
      name: ""
    };
  },
  watch: {
    shipClass(val) {
      if (val != "" || val != null) {
        this.name = "";
        this.shipType = "";
        this.vesselGroup = "";
        this.navigationStatus = "";
      }
    },
    name(val) {
      if (val != "" || val != null) {
        this.shipClass = "";
        this.shipType = "";
        this.vesselGroup = "";
        this.navigationStatus = "";
      }
    },
    shipType(val) {
      if (val != "" || val != null) {
        this.shipClass = "";
        this.name = "";
        this.vesselGroup = "";
        this.navigationStatus = "";
      }
    },
    vesselGroup(val) {
      if (val != "" || val != null) {
        this.shipClass = "";
        this.name = "";
        this.shipType = "";
        this.navigationStatus = "";
      }
    },
    navigationStatus(val) {
      if (val != "" || val != null) {
        this.shipClass = "";
        this.name = "";
        this.shipType = "";
        this.vesselGroup = "";
      }
    }
  },
  computed: {},
  methods: {
    getVesselData() {
      axios
        .get(`${API_BASE_URL}/api/vessels.json`, {
          headers: {
            "X-User-Email": "api@excise-online.com",
            "X-User-Token": "m2Nc1hmx7s97eCA1FMYA"
          }
        })
        .then(response => {
          this.vesselData = response.data;
          console.log("vesselData : ", this.vesselData);
        })
        .catch(error => {
          console.log("vessel list API error:", error);
        });
    },

    findVessel() {
      if (this.name != "" || this.name != null) {
        if (this.shipType != "" || this.shipType != null) {
          if (this.navigationStatus != null || this.navigationStatus != "") {
          } else {
          }
        } else {
        }
      } else {
      }
    },

    flitterVessel() {
      console.log("find : data");
      if (this.name != "") {
        this.flitterVesselData = [];
        this.shipType = "";
        this.shipClass = "";
        this.vesselGroup = "";
        this.navigationStatus = "";
        for (var i = 0; i < this.vesselData.length; i++) {
          if (this.name == this.vesselData[i].mmsi) {
            this.flitterVesselData.push(this.vesselData[i]);
          }
        }
      } else if (this.shipClass != "") {
        this.shipType = "";
        this.name = "";
        this.vesselGroup = "";
        this.navigationStatus = "";
        this.flitterVesselData = [];
        for (var i = 0; i < this.vesselData.length; i++) {
          if (this.shipClass == this.vesselData[i].ship_class) {
            this.flitterVesselData.push(this.vesselData[i]);
          }
        }
      } else if (this.shipType != "") {
        this.flitterVesselData = [];
        this.name = "";
        this.shipClass = "";
        this.vesselGroup = "";
        this.navigationStatus = "";
        for (var i = 0; i < this.vesselData.length; i++) {
          if (this.shipType == this.vesselData[i].ship_type_name) {
            this.flitterVesselData.push(this.vesselData[i]);
          }
        }
      } else if (this.navigationStatus != "") {
        this.shipType = "";
        this.shipClass = "";
        this.vesselGroup = "";
        this.name = "";
        this.flitterVesselData = [];
        for (var i = 0; i < this.vesselData.length; i++) {
          if (
            this.navigationStatus == this.vesselData[i].navigation_status_name
          ) {
            this.flitterVesselData.push(this.vesselData[i]);
          }
        }
      }
      this.$store.dispatch("updateFilterVessel", this.flitterVesselData);
    }
  },
  components: {
    VuePerfectScrollbar
  }
};
</script>

<style lang="scss">
#theme-customizer {
  .vs-sidebar {
    position: fixed;
    z-index: 52000;
    width: 400px;
    max-width: 90vw;
  }
}

.customizer-btn-filter {
  position: fixed;
  top: 48%;
  right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  z-index: 50000;
}

.scroll-area--customizer {
  height: calc(100% - 5rem);
  border-style: inset;
}

.scroll-area--detail {
  height: 200px;
  border-style: inset;
  padding-left: 10px;
  padding-right: 10px;
}

.vessel-img {
  width: 100%;
  height: 150px;
  border-style: solid gray;
  border-radius: 10px;
  margin-top: 3px;
}
.value-text {
  color: blue;
}
.title-text {
  font-weight: bold;
}
</style>
